export default {
  setDisplay (state, payload) {
    state.display = payload
  },
  setAccount (state, payload) {
    state.account = payload
  }
}
